import createField from '../../utils/factory/createField';
import { faWeightHanging, faRuler } from '@fortawesome/free-solid-svg-icons';

export const unitFields = [
    {
        section: 'Informações da Unidade',
        fields: [
            createField({
                id: 'unit.name',
                label: 'Nome',
                type: 'text',
                placeholder: 'Digite o nome da unidade',
                isMulti: false,
                icon: faRuler
            }),
            createField({
                id: 'unit.abbreviation',
                label: 'Abreviação',
                type: 'text',
                placeholder: 'Digite a abreviação da unidade',
                isMulti: false,
                icon: faRuler
            }),
        ],
    },
];

export const unitAssociationFields = [
    {
        section: "Unidades Relacionadas",
        fields: [
            createField({
                id: "units",
                label: "Unidades",
                type: "multi-select",
                placeholder: "Selecione as unidades relacionadas",
                isMulti: true,
                fullWidth: true,
                icon: faWeightHanging,
            }),
        ],
    },
];
